import { render } from "./FeedList.vue?vue&type=template&id=2d387bf8&scoped=true"
import script from "./FeedList.vue?vue&type=script&lang=js"
export * from "./FeedList.vue?vue&type=script&lang=js"

import "./FeedList.vue?vue&type=style&index=0&id=2d387bf8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d387bf8"]])

export default __exports__